import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const ShippingDialogs = ({
  t,
  language,
  openChangeTypeOfPrice,
  onConfirmChangeTypeOfPrice,
  onCancelChangeTypeOfPrice,
  openDeleteRowArticles,
  editRowArticles,
  idCodeDeleteArticle,
  onChangeDeleteRow,
  onConfirmDeleteRow,
  onCancelDeleteRow,
}) => {
  const selectedArticle = Array.isArray(editRowArticles)
    ? (editRowArticles[0] ?? {})
    : (editRowArticles ?? {});

  return (
    <>
    <Dialog
      open={openChangeTypeOfPrice}
      onClose={onCancelChangeTypeOfPrice}
      PaperProps={{ className: "my-dialog-blue-paper" }}
    >
      <DialogTitle className="my-dialog-blue-title">
        {t("Button_Modify_Prices")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="my-dialog-blue-contentText">
          {t("Text_Modify_Prices").toUpperCase()}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="my-dialog-blue-actions">
        <Button onClick={onConfirmChangeTypeOfPrice} className="my-dialog-blue-button-cancel">
          {t("Button_YES")}
        </Button>
        <Button variant="contained" onClick={onCancelChangeTypeOfPrice} className="my-dialog-blue-button-copy">
          {t("Button_NO")}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={openDeleteRowArticles}
      onClose={onCancelDeleteRow}
      PaperProps={{ className: "my-dialog-paper-danger" }}
    >
      <DialogTitle className="my-dialog-title-danger">
        {t('Text_Delete')} {selectedArticle.indexrowarticle} - {selectedArticle.article_code} - {language === 'es'
          ? selectedArticle.article_namees
          : selectedArticle.article_nameen}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="my-dialog-contentText-danger">
          {t("Text_Line1")}<br />
          {t("Text_Line2")}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="idCode"
          label={t("Text_Label")}
          type="text"
          fullWidth
          variant="standard"
          className="my-dialog-input-danger"
          defaultValue={idCodeDeleteArticle}
          onChange={onChangeDeleteRow}
        />
      </DialogContent>
      <DialogActions className="my-dialog-actions">
        <Button onClick={onCancelDeleteRow} className="my-dialog-button-cancel-danger">
          {t("Button_Cancel")}
        </Button>
        <Button variant="contained" onClick={onConfirmDeleteRow} className="my-dialog-button-delete">
          {t("Button_Delete")}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

ShippingDialogs.propTypes = {
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  openChangeTypeOfPrice: PropTypes.bool.isRequired,
  onConfirmChangeTypeOfPrice: PropTypes.func.isRequired,
  onCancelChangeTypeOfPrice: PropTypes.func.isRequired,
  openDeleteRowArticles: PropTypes.bool.isRequired,
  editRowArticles: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
  idCodeDeleteArticle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeDeleteRow: PropTypes.func.isRequired,
  onConfirmDeleteRow: PropTypes.func.isRequired,
  onCancelDeleteRow: PropTypes.func.isRequired,
};

export default ShippingDialogs;
